module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_NOSQL.ad5850c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/NoSQL/Mobile_Carrosel_NOSQL.png
// module id = 194
// module chunks = 0